import { HttpRequestType } from 'bitmovin-player/modules/bitmovinplayer-core';
import { SS, SS_MA } from 'src/AAFPlayer/constants';
import { getDataOfConfigSteamsTypes } from './streams-types-config';
import Metadata from 'src/requests/apa/Metadata';
import storage from '../../../../components/DeviceStorage/DeviceStorage';
import store from 'src/store';
import Constants from 'src/AAF/Ads/Constans';

const getBitmovinApaConfig = () => {
    console.log('[PAUS] enter getBitmovinApaConfig');

    const configDefault = {
        default: {
            location: {
                ui: false,
            },
            playback: {
                autoplay: true,
                mute: true,
            },
            adaptation: {
                maxStartupBitrate: '500kbps',
            },
            buffer: {
                video: {
                    forwardduration: 10,
                    backwardduration: 6,
                },
                audio: {
                    forwardduration: 10,
                    backwardduration: 6,
                },
            },
        }
    };

    let bitmovinPlayerConfig = Metadata.get('bitmovin_config', configDefault);

    if(typeof bitmovinPlayerConfig !== "object") {
        bitmovinPlayerConfig = JSON.parse(bitmovinPlayerConfig);
    }

    const region = storage.getItem('region');
    const value = bitmovinPlayerConfig[region] ? bitmovinPlayerConfig[region] : bitmovinPlayerConfig['default'];

    // Se agrega la licencia, location para pruebas en code, playback para pruebas en code
    value.key = '27a9e9cf-2878-4449-868d-633b11d63a4d';
    value.location =  {
        ui: false,
    };
    value.playback = {
        autoplay: true,
        mute: true,
    };

    return value;
}

const addAnalytics = (configDefault, options) => {
   const { user } = store.getState();
    const { user_id = null } = user;

    configDefault.analytics = {
        key: '72c69ba5-5369-426d-bf33-f403b0282bb6',
        videoId: options.groupId ? options.groupId : '',
        title: options.playerMedia.group.common.title,
        isLive: false,
        customUserId: user_id ? `${user_id}` : null,
    };
};

const getAds = (configDefault, options) => {
    const { urlAds = '', publicity = "false" } = store.getState().ads || {};
    const validatePublicity = publicity === "true"
    const { TYPE_URL_ADS } = Constants || {};

    const addPropertyUrlAds = validatePublicity ? urlAds.replace('correlator=', 'correlator=[random]') : "";
    configDefault.advertising = {
        adBreaks: [
            {
                tag: {
                    url: addPropertyUrlAds,
                    type: TYPE_URL_ADS,
                },
            },
        ],
    };
};

const modeDebugger = (configDefault, debug = false) => {
    if (debug) {
        configDefault.logs = {
            level: 'debug',
            onLog: function (logLevel, message, moreInfo) {
                if (logLevel === 'error')
                    console.error(`❌ [BITMOVIN - LOG]: ${logLevel} - ${message}`);
                else if (logLevel === 'warn')
                    console.warn(`⚠️ [BITMOVIN - LOG]: ${logLevel} - ${message}`);
                else if (logLevel === 'debug')
                    console.debug(`🔍 [BITMOVIN - LOG]: ${logLevel} - ${message}`);
                moreInfo && console.info(`🚀 [BITMOVIN - LOG]: More Information`, moreInfo);
            },
        };
    }
};

const isHBOSS = (configDefault, options) => {
    const { challenge } = getDataOfConfigSteamsTypes(options);

    let challengeHBO = null;
    if (challenge && challenge.indexOf('tokenID') !== -1) {
        challengeHBO = challenge;

        configDefault.network = {
            preprocessHttpResponse: function (type, response) {
                console.log('=> PAU preprocessHttpResponse : ', type);
                // if (type === HttpRequestType.DRM_LICENSE_WIDEVINE) {
                //   console.log("-------test printing response------> ", JSON.stringify(response));
                // }

                return Promise.resolve(response);
            },
            preprocessHttpRequest: function (type, request) {
                // console.log('=> PAU request body', request)
                // console.log('=> PAU preprocessHttpRequest : ', type);
                // if (type === HttpRequestType.DRM_LICENSE_WIDEVINE) {
                //   console.log("-------test printing request------> ", JSON.stringify(request));
                //   console.log('=> PAU type body request stringify: ');
                // }

                if (bitmovin && type === HttpRequestType.DRM_LICENSE_PLAYREADY) {
                    // You might want to add additional checks to ensure it's only done for HBO content
                    console.log('=> PAU type DRM_LICENSE_PLAYREADY: ', request.body);
                    request.body = request.body.replace(
                        '</AcquireLicense>',
                        '</AcquireLicense><CustomData>' + challengeHBO + '</CustomData>'
                    );
                    console.log(
                        '=> PAU type DRM_LICENSE_PLAYREADY json: ',
                        JSON.stringify(request.body)
                    );
                }

                return Promise.resolve(request);
            },
        };
    }
};

export const getBitmovinConfig = (options, logs = false) => {
    const configDefault = getBitmovinApaConfig();
    modeDebugger(configDefault, logs);
    addAnalytics(configDefault, options);
    getAds(configDefault, options);
    (options.streamType === SS || options.streamType === SS_MA) && isHBOSS(configDefault, options);

    return configDefault;
};



// WEBPACK FOOTER //
// ./src/devices/all/bitmovin/utils/configBitmovinPlayer.js